import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '../../../../providers';

import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';

export const useAdminTools = () => {
  const { t: translate } = useTranslation();
  const { sendMessageToUnreal, sendMessageToEvent } = useMytaverse();
  const { conferenceName } = useCommunications();

  const {
    setOpenAdminSettingsModal,
    currentEvent,
    currentParticipant,
    isDroneMode,
    setIsDroneMode,
  } = useMytaverseEvent();

  const handleDroneMode = useCallback(() => {
    const unrealAction = isDroneMode
      ? WebsocketAction.DisableDroneCamera
      : WebsocketAction.EnableDroneCamera;

    setIsDroneMode(!isDroneMode);
    sendMessageToUnreal({
      action: unrealAction,
    });
  }, [isDroneMode, sendMessageToUnreal, setIsDroneMode]);

  const handleMuteAll = useCallback(() => {
    if (!currentEvent || !currentParticipant) {
      return;
    }
    sendMessageToEvent(currentEvent.eventId, {
      action: WebsocketAction.MuteConference,
      mutedBy: currentParticipant.participantId,
      conferenceId: conferenceName,
    });
  }, [currentEvent, currentParticipant, sendMessageToEvent, conferenceName]);

  const handleLevelEditor = useCallback(() => {
    sendMessageToUnreal({
      action: WebsocketAction.ToggleLevelEditor,
    });
  }, [sendMessageToUnreal]);

  const handleOpenAdminSettings = () => {
    setOpenAdminSettingsModal(true);
  };

  return {
    translate,
    handleDroneMode,
    handleOpenAdminSettings,
    handleMuteAll,
    handleLevelEditor,
  };
};
